import { get, save, create, remove } from './http';
import {zeroPad} from '../../components/utils/format';

function rangeFormat(range){
    let [startDate,endDate] = [range.start,range.end].map( d => d instanceof Date ? `${zeroPad(d.getMonth()+1,2)}-${zeroPad(d.getDate(),2)}-${d.getFullYear()}` : '');
    return startDate && endDate ? {startDate,endDate} : {};
}


export function getOrders({type = 'pending',count = 20,offset = 0,filter = {}}){
    let filterFormatted = filter.type === 'dates' ? rangeFormat(filter.date) : filter.type ? {[filter.type]: filter.value} : {};
    return get(`orders`,{type,count,offset,...filterFormatted});
}

export function getOrder(Id){
    //return new Promise( (resolve,reject) => setTimeout( () => get(`order`,{Id}).then(resolve).catch(reject), 5000 ));
    if(!Id){
        return new Promise((resolve,reject) => reject());
    }
    return get(`order`,{Id});
}

export function newOrder(){
    return create(`order`);
}

export function setSelected({Id}){
    return save(`ordersSetSelected`,{Id});
}

export function itemQuantSet({Order, Part, Price, Condition, Quantity, Searched, WarehouseId, add}){
    return save(add ? `orderAddItem` : `orderSetItemQuant`,{OrderId:Order, PartId:Part, Price, Condition, Quantity, Searched, WarehouseId});
}

export function removeItem({Order, Part, Price, Condition, WarehouseId}){
    return remove(`orderRemoveItem`,{OrderId:Order, PartId:Part, Price, Condition, WarehouseId});
}

export function itemImport({Id,Items,CATOnly}){
    return save(`orderImportItems`,{Id,Items,CATOnly});
}

export function saveOrderName({Id, Name}){
    return save(`orderSetName`,{Id, Name});
}

export function saveOrderAddress({Id, Address}){
    return save(`orderSetAddress`,{Id, Address});
}

export function saveOrderPayment({Id, Payment}){
    return save(`orderSetPayment`,{Id, Payment});
}

export function saveOrderShippingMethods({Id, ShippingLocations}){
    return save(`orderSetShippingMethods`,{Id, ShippingLocations});
}

export function submitOrder({Id,BlindShip,CustPONum,SpecialShippingInstructions,Phone,ContactName,Payment}){
    return save(`orderSubmit`,{Id,BlindShip,CustPONum,SpecialShippingInstructions,Phone,ContactName,Payment});
}

export function removeOrder({Id}){
    return remove(`order`,{Id});
}